export default "__VITE_ASSET__05ce347e__"